export default "__VITE_ASSET__Bbyaa3f3__"